import { memo } from "react";
import { FullscreenLoader } from "./FullscreenLoader";
import { useFullscreenLoader } from "./index";

export const FullscreenLoaderContainer = memo(() => {
  const { processes } = useFullscreenLoader();
  const lastProcess = processes?.[processes.length - 1];
  return (
    <FullscreenLoader
      processId={lastProcess?.processId}
      description={lastProcess?.description}
      progress={lastProcess?.progress}
    />
  );
});

export default FullscreenLoaderContainer;
